import React, { createContext, useContext, useState } from "react";

const TransferSearchContext = createContext();

export const useTransferSearch = () => useContext(TransferSearchContext);

const defaultSearchData = {
	from: null,
	to: null,
	date: null,
	time: { hour: null, minute: null },
	passengers: 1,
};

export const TransferSearchProvider = ({ children }) => {
	const [searchData, setSearchData] = useState(defaultSearchData);
	const resetSearchData = () => setSearchData(defaultSearchData);

	return (
		<TransferSearchContext.Provider value={{ searchData, setSearchData, resetSearchData }}>
			{children}
		</TransferSearchContext.Provider>
	);
};
